// extracted by mini-css-extract-plugin
export default {"formHeader":"RequestPetAdditionForm_formHeader__5GwMJ","formPrompt":"RequestPetAdditionForm_formPrompt__t3oYs","formContent":"RequestPetAdditionForm_formContent__qAFLF"};